import React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import $ from 'jquery';
import { ReactSVG } from 'react-svg';
import DateInput from '@/components/DateInput';
import { locationOpt } from '@/actions/Helper';
import { Icons } from '@/assets';
import styles from './styles';
import CustomDateInput from '@/components/CustomDateInput';
import CustomAsyncSelect from '@/components/CustomAsyncSelect';
import CustomSelectEx from '@/ctComponents/CustomSelectEx';
import { CustomGrid, CustomGridItem } from '@/ctComponents/Grid';
import SubmitButton from '@/ctComponents/submitButton';
import CloseButton from '@/ctComponents/closeButton';

export default ({
  title,
  DATA = [],
  filter = {},
  setFilter,
  children,
  companies,
  whatsappBy,
  whatsappDatePosted,
  whatsappCompany,
  filterWithApi,
  withDateFilter,
  type,
  noTitleAndIcon = false,
  activeTab,
}) => {
  const cls = styles();
  const selectOp = useSelector((state) => state.reducer);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [resetLoading, setResetLoading] = React.useState(false);

  const [form, setFormData] = React.useState({
    size: null,
    ssl: null,
    loc: null,
    locex: null,
    erd: null,
    cutoff: null,
    lfd: null,
    chassis: {
      own: true,
      pool: true,
    },
  });
  const Reset = () => {
    setResetLoading(true);
    setFormData({
      size: null,
      ssl: null,
      loc: null,
      locex: null,
      erd: null,
      cutoff: null,
      lfd: null,
      chassis: {
        own: true,
        pool: true,
      },
    });
    setTimeout(() => {
      setFilter({ ...filter, DATA: undefined, appliedFilters: {} });
      if (filterWithApi)
        filterWithApi({
          size: null,
          ssl: null,
          loc: null,
          locex: null,
          erd: null,
          cutoff: null,
          lfd: null,
          chassis: {
            own: true,
            pool: true,
          },
        });
      setResetLoading(false);
    }, 500);
  };
  const setForm = (i, v) => setFormData({ ...form, [i]: v });

  React.useEffect(() => {
    if (filter.open) $('.filter-card').slideDown();
    else $('.filter-card').slideUp();
  }, [filter.open]);

  // Reset form when activeTab changes
  React.useEffect(() => {
    setFormData({
      size: null,
      ssl: null,
      loc: null,
      locex: null,
      erd: null,
      cutoff: null,
      lfd: null,
      chassis: {
        own: true,
        pool: true,
      },
    });
  }, [activeTab]);

  // Clear specific field when filter badge is removed
  React.useEffect(() => {
    if (filter.removedFilter) {
      setFormData((prevForm) => ({
        ...prevForm,
        [filter.removedFilter]: null,
      }));

      // Clear the removedFilter flag after processing
      setTimeout(() => {
        setFilter((prevFilter) => ({
          ...prevFilter,
          removedFilter: null,
        }));
      }, 100);
    }
  }, [filter.removedFilter, setFilter]);

  const Filter = () => {
    setSubmitLoading(true);
    let arr = DATA;

    // Handle different data structures
    if (form.size) {
      arr = arr.filter((i) => {
        const size =
          i.size ||
          i.specification?.size_type ||
          (i.containers && i.containers[0]?.size);
        return size === form.size.label;
      });
    }

    if (form.ssl) {
      arr = arr.filter((i) => {
        const ssl =
          i.ssl || i.company?.name || (i.containers && i.containers[0]?.ssl);

        return ssl === form.ssl.label;
      });
    }

    if (form.loc) {
      arr = arr.filter((i) => {
        // For dropped tab: i.loc
        // For load/all tab: i.return_terminals
        const loc =
          i.loc || i.return_terminals || (i.containers && i.containers[0]?.loc);
        return loc && form.loc.label.includes(loc);
      });
    }

    // if (form.date) arr = arr.filter((i) => i.size === form.size);
    if (form.num) arr = arr.filter((i) => i.num <= form.num);
    if (form.company) arr = arr.filter((i) => i.company <= form.company);

    // Store applied filters for indicator
    const appliedFilters = {};
    if (form.size) appliedFilters.size = form.size.label;
    if (form.ssl) appliedFilters.ssl = form.ssl.label;
    if (form.loc) appliedFilters.loc = form.loc.label;

    setFilter({ ...filter, DATA: arr, open: false, appliedFilters });
    setTimeout(() => {
      setSubmitLoading(false);
    }, 500);
  };

  const Close = () => setFilter({ ...filter, open: false });
  const Toggle = () => setFilter({ ...filter, open: !filter.open });

  return (
    <div className={cls.filterContainer}>
      {!noTitleAndIcon && (
        <div className={cls.headerBar}>
          <span className={cls.title}>{title}</span>

          <div className={cls.row3}>
            {children}
            <div className={cls.filterRow} onClick={Toggle}>
              <span className={cls.title}>Filter</span>
              <ReactSVG src={Icons.filter} className={cls.filter} />
            </div>
          </div>
        </div>
      )}
      <div
        className={clsx(cls.card, 'filter-card')}
        style={{ display: 'none' }}>
        {type !== 'streetTurn' ? (
          <CustomGrid container spacing={2}>
            <CustomGridItem item xs={12} sm={6} md={3}>
              <CustomSelectEx
                dropdown
                minHeight={48}
                isClearable
                placeholder="Size"
                className={cls.select}
                value={form.size}
                onChange={(item) => setForm('size', item)}
                options={selectOp.size}
              />
            </CustomGridItem>
            <CustomGridItem item xs={12} sm={6} md={3}>
              <CustomSelectEx
                dropdown
                minHeight={48}
                isClearable
                placeholder="SSL"
                className={clsx(cls.select)}
                value={form.ssl}
                onChange={(item) => setForm('ssl', item)}
                options={selectOp.ssl}
              />
            </CustomGridItem>
            <CustomGridItem item xs={12} sm={6} md={3}>
              <CustomAsyncSelect
                dropdown
                isClearable
                minHeight={48}
                placeholder="Location"
                className={cls.loc}
                value={form.loc}
                loadOptions={(e) => locationOpt(e)}
                onChange={(item) => setForm('loc', item)}
                cacheOptions
                defaultOptions
              />
            </CustomGridItem>
            {withDateFilter && (
              <CustomGridItem item xs={12} sm={6} md={3}>
                <CustomDateInput
                  placeholder="Date"
                  minHeight={48}
                  className={cls.dateSelector}
                  format="MM/dd/yyyy"
                  value={form.date}
                  onChange={(item) => setForm('date', item)}
                />
              </CustomGridItem>
            )}
            {companies && (
              <CustomGridItem item xs={12} sm={6} md={3}>
                <Select
                  isClearable
                  placeholder="Company"
                  className={clsx(cls.select)}
                  value={form.company}
                  onChange={(item) => setForm('company', item)}
                  options={companies}
                />
              </CustomGridItem>
            )}
            {companies && (
              <CustomGridItem item xs={12} sm={6} md={3}>
                <Select
                  isClearable
                  placeholder="Company"
                  className={clsx(cls.select)}
                  value={form.company}
                  onChange={(item) => setForm('company', item)}
                  options={companies}
                />
              </CustomGridItem>
            )}
            {whatsappBy && (
              <CustomGridItem item xs={12} sm={6} md={3}>
                <Select
                  isClearable
                  placeholder="By"
                  className={clsx(cls.select)}
                  value={form.company}
                  onChange={(item) => setForm('By', item)}
                  options={companies}
                />
              </CustomGridItem>
            )}
            {whatsappDatePosted && (
              <CustomGridItem item xs={12} sm={6} md={3}>
                <DateInput
                  placeholder="Date Posted"
                  className={cls.date}
                  format="MM/dd/yyyy"
                  value={form.date}
                  onChange={(item) => setForm('dateposted', item)}
                />
              </CustomGridItem>
            )}
            {whatsappCompany && (
              <CustomGridItem item xs={12} sm={6} md={3}>
                <Select
                  isClearable
                  placeholder="Company"
                  className={clsx(cls.select)}
                  value={form.company}
                  onChange={(item) => setForm('company', item)}
                  options={companies}
                />
              </CustomGridItem>
            )}
            <CustomGridItem item xs={12} sm={6} md={3}>
              <div className={cls.row2}>
                <CloseButton
                  color={'#131517'}
                  text={'Reset'}
                  onClick={() => Reset()}
                  loading={resetLoading}
                />
                <SubmitButton
                  text="Apply"
                  loading={submitLoading}
                  onClick={() => {
                    if (type === 'streetTurn') {
                      filterWithApi(form);
                      setFilter({ ...filter, open: false });
                    } else if (filterWithApi) {
                      filterWithApi(form);
                      setFilter({ ...filter, open: false });
                    } else {
                      Filter();
                    }
                  }}
                />
              </div>
            </CustomGridItem>
          </CustomGrid>
        ) : (
          <CustomGrid container spacing={2}>
            <CustomGridItem item xs={12} sm={4} md={3}>
              <div className={`${cls.input} ${cls.containerInput}`}>
                <span className={cls.containerBadge}>{`Size `}</span>
                <Select
                  isClearable
                  placeholder="Size"
                  className={cls.selecttt}
                  value={form.size}
                  onChange={(item) => setForm('size', item)}
                  options={selectOp.size}
                />
              </div>
            </CustomGridItem>
            <CustomGridItem item xs={12} sm={4} md={3}>
              <div className={`${cls.input} ${cls.containerInput}`}>
                <span className={cls.containerBadge}>{`SSL`}</span>
                <Select
                  isClearable
                  placeholder="SSL"
                  className={clsx(cls.selecttt)}
                  value={form.ssl}
                  onChange={(item) => setForm('ssl', item)}
                  options={selectOp.ssl}
                />
              </div>
            </CustomGridItem>
            <CustomGridItem item xs={12} sm={4} md={3}>
              <div className={`${cls.input} ${cls.containerInput}`}>
                <span className={cls.containerBadge}>{`Empty Loc. `}</span>
                <AsyncSelect
                  isClearable
                  placeholder=""
                  className={cls.loccc}
                  value={form.loc}
                  loadOptions={locationOpt}
                  onChange={(item) => setForm('loc', item)}
                  cacheOptions
                  defaultOptions
                />
              </div>
            </CustomGridItem>
            <CustomGridItem item xs={12} sm={4} md={3}>
              <div className={`${cls.input} ${cls.containerInput}`}>
                <span className={cls.containerBadge}>{`LFD `}</span>
                <DateInput
                  isClearable
                  placeholder="LFD"
                  className={cls.date}
                  format="MM/dd/yyyy"
                  value={form.lfd}
                  onChange={(item) => setForm('lfd', item)}
                />
              </div>
            </CustomGridItem>
            <CustomGridItem item xs={12} sm={4} md={3}>
              <div className={`${cls.input} ${cls.containerInput}`}>
                <span className={cls.containerBadge}>{`ERD `}</span>
                <DateInput
                  isClearable
                  placeholder="ERD"
                  className={cls.date}
                  format="MM/dd/yyyy"
                  value={form.erd}
                  onChange={(item) => setForm('erd', item)}
                />
              </div>
            </CustomGridItem>
            <CustomGridItem item xs={12} sm={4} md={3}>
              <div className={`${cls.input} ${cls.containerInput}`}>
                <span className={cls.containerBadge}>{`CutOff `}</span>
                <DateInput
                  isClearable
                  placeholder="CutOff"
                  className={cls.date}
                  format="MM/dd/yyyy"
                  value={form.cutoff}
                  onChange={(item) => setForm('cutoff', item)}
                />
              </div>
            </CustomGridItem>
            <CustomGridItem item xs={12} sm={4} md={3}>
              <div className={`${cls.input} ${cls.containerInput}`}>
                <span className={cls.containerBadge}>{`Export Loc. `}</span>
                <AsyncSelect
                  isClearable
                  placeholder=""
                  className={cls.loccc}
                  value={form.locex}
                  loadOptions={locationOpt}
                  onChange={(item) => setForm('locex', item)}
                  cacheOptions
                  defaultOptions
                />
              </div>
            </CustomGridItem>
            <CustomGridItem item xs={12} sm={4} md={3}>
              <div className={cls.containerActions}>
                <div className={cls.containerRowRound}>
                  <span
                    onClick={() =>
                      setForm('chassis', {
                        own: !form.chassis.own,
                        pool:
                          !form.chassis.own === false
                            ? true
                            : form.chassis.pool,
                      })
                    }
                    className={clsx(
                      cls.chassisText,
                      form.chassis.own && cls.activeChassis
                    )}>
                    Own Chassis
                  </span>
                  <span
                    onClick={() =>
                      setForm('chassis', {
                        pool: !form.chassis.pool,
                        own:
                          !form.chassis.pool === false
                            ? true
                            : form.chassis.own,
                      })
                    }
                    className={clsx(
                      cls.chassisText,
                      form.chassis.pool && cls.activeChassis
                    )}>
                    Pool Chassis
                  </span>
                </div>
              </div>{' '}
            </CustomGridItem>
          </CustomGrid>
        )}
        {type === 'streetTurn' && (
          <div className={cls.row2}>
            <CloseButton
              color={'#131517'}
              text={'Reset'}
              onClick={() => Reset()}
              loading={resetLoading}
            />
            <SubmitButton
              text="Apply"
              loading={submitLoading}
              onClick={() => {
                setSubmitLoading(true);
                if (type === 'streetTurn') {
                  filterWithApi(form);
                  setFilter({ ...filter, open: false });
                } else if (filterWithApi) {
                  filterWithApi(form);
                  setFilter({ ...filter, open: false });
                } else {
                  Filter();
                }
                setSubmitLoading(false);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
